import ScrollToItem from "./scroll-to-item";

class HashCheckToScroll {
    constructor(hash) {
        try {
            if (hash) {
                const targetElement = document.querySelector(hash);

                if (targetElement) {
                    new ScrollToItem(document, hash);
                }
            }

        } catch (error) {
            console.log(error);
        }
    }

}
export default HashCheckToScroll;